import { c as _c } from "react/compiler-runtime";
import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import type { InterfaceInputToken } from '@morpho-org/dapp-core';
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { isDefined } from '@morpho-org/morpho-ts';
import { Avatar } from '@morpho-org/ui-v6/client';
import { getMarketNameParts } from '@morpho-org/ui-v6/utils';
import { TruncatedTooltip } from '@repo/ui';
import { getMarketUrl } from '@/helpers/routing';
import { getTimelockFunctionConfig } from '../utils';
import { HoverableStack } from '../VaultPendingTimelock.components';
import VaultPendingTimelockHeader from './VaultPendingTimelockHeader';
interface VaultPendingTimelockRemoveMarketProps {
  chainId: ChainId;
  collateralAsset: InterfaceInputToken | null;
  loanAsset: InterfaceInputToken;
  functionName: string;
  marketId: MarketId;
}
const VaultPendingTimelockRemoveMarket = t0 => {
  const $ = _c(15);
  const {
    chainId,
    functionName,
    collateralAsset,
    loanAsset,
    marketId
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const config = t1;
  let t2;
  if ($[2] !== collateralAsset || $[3] !== loanAsset) {
    t2 = getMarketNameParts({
      loanAsset,
      collateralAsset
    });
    $[2] = collateralAsset;
    $[3] = loanAsset;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    loanSymbol,
    collateralSymbol
  } = t2;
  let t3;
  if ($[5] !== chainId || $[6] !== collateralAsset || $[7] !== collateralSymbol || $[8] !== config || $[9] !== loanAsset || $[10] !== loanSymbol || $[11] !== marketId) {
    t3 = config && <VaultPendingTimelockHeader title={config.label} criticality={config.criticality}>{isDefined(marketId) && <HoverableStack onClick={e => {
        e.stopPropagation();
        const url = getMarketUrl({
          identifier: InterfaceChainUtils.getIdentifierById(chainId),
          marketId,
          collateralSymbol: collateralAsset?.symbol ?? "",
          loanSymbol: loanAsset.symbol ?? ""
        });
        window.open(url, "_blank");
      }}><div className="gap-xs text-2xs text-foreground flex min-w-[0px] items-center"><span className="gap-xs inline-flex shrink-0 items-center"><Avatar aria-hidden={true} src={loanAsset.logoURI} size="small" /><TruncatedTooltip text={loanSymbol}>{ref => <span ref={ref} tabIndex={-1} className="min-w-0 truncate">{loanSymbol}</span>}</TruncatedTooltip></span>{collateralAsset && <><span aria-hidden={true} className="bg-muted-foreground h-sm w-px shrink-0 rounded-full" /><span className="sr-only">backed by</span><span className="gap-xs inline-flex min-w-0 items-center"><Avatar aria-hidden={true} src={collateralAsset.logoURI} size="small" /><TruncatedTooltip text={collateralSymbol ?? ""}>{ref_0 => <span ref={ref_0} tabIndex={-1} className="min-w-0 truncate">{collateralSymbol}</span>}</TruncatedTooltip></span></>}</div></HoverableStack>}</VaultPendingTimelockHeader>;
    $[5] = chainId;
    $[6] = collateralAsset;
    $[7] = collateralSymbol;
    $[8] = config;
    $[9] = loanAsset;
    $[10] = loanSymbol;
    $[11] = marketId;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <div className="flex w-[100%] flex-col">{t3}</div>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default VaultPendingTimelockRemoveMarket;